var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e, _f;
import { makeAutoObservable } from "mobx";
import { perRestaurant } from "../di";
import { t, translate } from "../I18n";
import { LocalizationProvider } from "../locale";
import { BottomSheetCrossSellingCreator, CrossSellingItemInstancePriceService, OrderLine, Price, PurchaseOrderPayload, } from "../ordering";
import { PCrossSellingCreatorFactory } from "./PCrossSellingCreatorFactory";
import { PPrice } from "./PPrice";
import { OrderItemListTracking } from "./OrderItemListTracking";
const MAX_ELEMENTS_TO_SHOW = 3;
let PCrossSellingBottomSheet = class PCrossSellingBottomSheet {
    constructor(pCrossSellingCreatorFactory, domainCrossSellingCreator, crossSellingItemInstancePriceService, localizationProvider, purchaseOrderPayload, orderItemListTracking) {
        this.domainCrossSellingCreator = domainCrossSellingCreator;
        this.crossSellingItemInstancePriceService = crossSellingItemInstancePriceService;
        this.localizationProvider = localizationProvider;
        this.purchaseOrderPayload = purchaseOrderPayload;
        this.orderItemListTracking = orderItemListTracking;
        this.crossSellingCreator = pCrossSellingCreatorFactory.create(domainCrossSellingCreator);
        makeAutoObservable(this);
    }
    get crossSellingItems() {
        return this.crossSellingCreator.items.raw.slice(0, MAX_ELEMENTS_TO_SHOW);
    }
    get price() {
        return Price.total(this.domainCrossSellingCreator.items.map((crossSellingItemInstance) => this.crossSellingItemInstancePriceService.totalPrice(crossSellingItemInstance)));
    }
    get pPrice() {
        return new PPrice(this.localizationProvider, this.price.spectrum);
    }
    // Only for tracking (analytics) purposes
    get trackingPrice() {
        var _a;
        return (_a = this.price.finalValue) !== null && _a !== void 0 ? _a : null;
    }
    get buttonText() {
        if (this.price.compare(Price.free()) > 0) {
            return {
                label: translate(t.client.cross_selling_bottomsheet.button.add),
                price: this.pPrice.priceValue,
            };
        }
        else {
            return {
                label: translate(t.client.cross_selling_bottomsheet.button.continue),
                price: null,
            };
        }
    }
    cleanSelectedItems() {
        this.domainCrossSellingCreator.cleanSelectedItems();
    }
    addToCart(place) {
        this.domainCrossSellingCreator.items.raw.map((item) => {
            if (!item.quantity.isZero) {
                this.orderItemListTracking.collectProductData(item.itemCreator.trackingId, {
                    tag: "CrossSelling",
                    kind: item.kind,
                    place,
                });
                this.purchaseOrderPayload.addOrderLine(new OrderLine({
                    productInstanceCreator: item.itemCreator,
                    quantity: item.quantity,
                }));
            }
        });
    }
};
PCrossSellingBottomSheet = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof PCrossSellingCreatorFactory !== "undefined" && PCrossSellingCreatorFactory) === "function" ? _a : Object, typeof (_b = typeof BottomSheetCrossSellingCreator !== "undefined" && BottomSheetCrossSellingCreator) === "function" ? _b : Object, typeof (_c = typeof CrossSellingItemInstancePriceService !== "undefined" && CrossSellingItemInstancePriceService) === "function" ? _c : Object, typeof (_d = typeof LocalizationProvider !== "undefined" && LocalizationProvider) === "function" ? _d : Object, typeof (_e = typeof PurchaseOrderPayload !== "undefined" && PurchaseOrderPayload) === "function" ? _e : Object, typeof (_f = typeof OrderItemListTracking !== "undefined" && OrderItemListTracking) === "function" ? _f : Object])
], PCrossSellingBottomSheet);
export { PCrossSellingBottomSheet };
